import React from "react"
import { Row, Col, Button } from "antd"
import PropTypes from "prop-types"

const PaymentActions = ({ onCancel, onSubmit, isSubmitting, isDisabled }) => {
  return (
    <Row justify="start" gutter={12} className="mt-m">
      <Col>
        <Button onClick={onCancel}>Cancel</Button>
      </Col>
      <Col>
        <Button
          type="primary"
          onClick={onSubmit}
          disabled={isDisabled}
          loading={isSubmitting}
        >
          Confirm
        </Button>
      </Col>
    </Row>
  )
}

PaymentActions.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired
}

export default PaymentActions
